const defaultDimension = {
    width: 750,
    height: 450
};
const providersOptions = {
    sberbank: {
        title: 'Сбер ID',
        width: 1024,
        height: 750
    },
    apple: {
        title: 'Apple ID',
        width: 650,
        height: 750
    },
    livejournal: {
        title: 'LiveJournal',
        width: 750,
        height: 650
    },
    pgumosru: {
        title: 'mos.ru',
        width: 750,
        height: 650
    },
    google: {
        title: 'Google',
        width: 650,
        height: 700
    },
    instagram: {
        title: 'Instagram',
        width: 750,
        height: 650
    },
    webauthn: {
        title: 'Электронный ключ',
        ...defaultDimension
    },
    vkontakte: {
        title: 'ВКонтакте',
        ...defaultDimension
    },
    facebook: {
        title: 'Facebook',
        ...defaultDimension
    },
    odnoklassniki: {
        title: 'Одноклассники',
        ...defaultDimension
    },
    mailru: {
        title: 'Mail.Ru',
        ...defaultDimension
    },
    twitter: {
        title: 'Twitter',
        ...defaultDimension
    },
    mail: {
        title: 'С помощью почты'
    },
    phone: {
        title: 'По номеру телефона'
    },
    championat: {
        title: 'Championat',
        ...defaultDimension
    }
};
export const getProvidersOptions = (allowedProviders) => allowedProviders.reduce((acc, key) => ({ ...acc, [key]: providersOptions[key] }), {});
export const providers = Object.keys(providersOptions).filter((provider) => provider !== 'mail' && provider !== 'phone');
